import { Typography } from '@mui/material'
// helper
import { getLinkText } from '$func/link'

export function linkViewer(key: string, result: string[]) {
  const link = getLinkText(result[0])
  return (
    <Typography key={key} variant="paragraph3" color="gray" dir="ltr">
      {link}
    </Typography>
  )
}
